import { Link } from 'react-router-dom';
import { PLATFORM_LABELS, postStatusView } from '../../../../lib/socialPostView';
import type { ClientPost } from './socialApi';

export const TONE: Record<string, string> = {
  neutral: 'bg-muted text-foreground',
  // Theme tokens (index.css --tone-*), each with a real dark value.
  info: 'bg-tone-info text-tone-info-foreground',
  success: 'bg-tone-success text-tone-success-foreground',
  warning: 'bg-tone-warning text-tone-warning-foreground',
  danger: 'bg-tone-danger text-tone-danger-foreground',
};

export function PostRow({ post, accountParam }: { post: ClientPost; accountParam: string }) {
  const view = postStatusView(post.status, post.scheduledFor);
  const platforms = [...new Set(post.targets.map((t) => PLATFORM_LABELS[t.platform] ?? t.platform))].join(', ');
  return (
    <li className="rounded-md border border-border p-3" data-testid="post-row">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`rounded px-2 py-0.5 text-xs font-semibold ${TONE[view.tone]}`}>{view.label}</span>
        <span className="text-xs text-muted-foreground">{platforms}</span>
        <span className="text-xs text-muted-foreground">{view.sentence}</span>
      </div>
      {post.media.length > 0 && (
        <div className="mt-2 flex gap-2" data-testid="post-media">
          {post.media.slice(0, 4).map((m) =>
            m.type === 'video' && !m.thumbnailUrl ? (
              <video key={m.url} src={m.url} preload="metadata" className="h-16 w-16 rounded object-cover" />
            ) : (
              <img key={m.url} src={m.thumbnailUrl ?? m.url} alt={m.altText ?? ''} loading="lazy" className="h-16 w-16 rounded object-cover" />
            ),
          )}
          {post.media.length > 4 && <span className="self-center text-xs text-muted-foreground">+{post.media.length - 4}</span>}
        </div>
      )}
      <p className="mt-2 line-clamp-3 whitespace-pre-wrap text-sm text-foreground">{post.content || '(no caption)'}</p>
      {post.publishError && (
        <p className="mt-2 text-sm text-destructive" role="alert">
          {post.publishError}
        </p>
      )}
      <div className="mt-2 flex gap-3 text-sm">
        <Link className="underline" to={`/portal/social/posts/${encodeURIComponent(post.id)}?account=${encodeURIComponent(accountParam)}`}>
          {post.status === 'published' || post.status === 'partial' ? 'View' : 'Open'}
        </Link>
        {post.targets
          .filter((t) => t.publishedUrl)
          .map((t) => (
            <a key={t.platform} className="underline" href={t.publishedUrl!} target="_blank" rel="noreferrer">
              See on {PLATFORM_LABELS[t.platform] ?? t.platform}
            </a>
          ))}
      </div>
    </li>
  );
}
